import React, { useEffect, Suspense, useState } from 'react';
import { connect } from 'react-redux';
import GuestHeader from './GuestHeader';
import Navigation from './Navigation/Navigation';
import NavigationRuntime from './Navigation-runtime/Navigation';
import Logo from './Logo';
import SearchBar from './SearchBar';
import Wishlist from './Wishlist';
import Cart from './Cart';
import * as actions from '../../../actions/homeData';
import properties from '../../../modules/ajio-util/properties';
import {
  getRuntimeBannersFlag,
  getRuntimeBannersSisFlag,
  getLuxeFlags,
  getEarlyAccessFlag
} from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import PriceRevealPLPBanner from '../../common/PriceRevealPLPBanner';
import EarlyAccessBanner from '../../common/PriceRevealPLPBanner/EarlyAccessBanner';
import { checkEarlyAccessUser } from '../../common/Cookie';
import { signInCheck } from '../../common/CheckUserStatus';
import { getRuntimeBanners } from '../../../actions/homeData';
import { getPriceRevealSaleDuration } from '../../common/PriceRevealPLPBanner/priceRevealUtil';
import { DURING_SALE } from '../../../refresh/constants/product.constants';
import { STREET_STORE } from '../../../constants/constant';
import { getStreetFlags } from '../../../refresh/selectors/featureFlagsSelector';

const PlpExtendedBanner = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/SizeGuide" */ '../../../refresh/organism/PlpExtendedBanner'
  )
);
const imageBaseUrl = properties.getProperty('imageBaseUrl');

const Header = props => {
  const {
    category = true,
    metaData: {
      sis = false,
      name = '',
      subHeaderHeight = 0,
      primaryHeaderHeight = 100,
      subHeaderLogoHeight = 0,
      current: {
        colorTheme = '',
        textColor = '',
        headerIconColor = '',
        biggerLogo: subBrandLogo = `${imageBaseUrl}/static/img/Ajio-Logo.png`,
        subdomain = ''
      } = {}
    } = {},
    runtimeBanners,
    runtimeBannersSis,
    isStore,
    newDesignLuxe,
    earlyAccessFlag,
    priceRevealMetaInfo,
    flags,
    isStreet,
    storeName,
  } = props;

  const NavComp =
    (isStore && runtimeBannersSis === 'ON') || (!isStore && runtimeBanners === 'ON')
      ? NavigationRuntime
      : Navigation;
  const headerStripHeight = newDesignLuxe ? 'auto' : `${subHeaderHeight}px`;
  const priceRevealState = getPriceRevealSaleDuration(flags, 'desktop', priceRevealMetaInfo, name);
  const isSignedIn = signInCheck();
  const isEarlyAccessUser = isSignedIn && earlyAccessFlag && checkEarlyAccessUser(name, 'cms');

  return (
    <div className={`${newDesignLuxe && 'luxe-newdesign'} header-wrapper`}>
      <div className="main-header dodShadow" style={{ height: `${primaryHeaderHeight}px` }}>
        <header>
          <GuestHeader />
          <Logo sis={sis} newDesignLuxe={newDesignLuxe} isStreetStore={isStreet} />
          <div className="header-right">
            {(!sis || isStreet) && <NavComp category={category} newDesignLuxe={newDesignLuxe} />}
            <div className="scb">
              <SearchBar newDesignLuxe={newDesignLuxe} isStreetStore={isStreet} />
              <Wishlist newDesignLuxe={newDesignLuxe} isStreetStore={isStreet} />
              <Cart newDesignLuxe={newDesignLuxe} isStreetStore={isStreet} />
            </div>
          </div>
        </header>
        {!newDesignLuxe &&
          (isEarlyAccessUser && priceRevealState !== DURING_SALE ? (
            <EarlyAccessBanner deviceType="desktop" />
          ) : (
            <PriceRevealPLPBanner deviceType="desktop" />
          ))}
      </div>
      {sis && storeName !== STREET_STORE ? (
        <div
          className="sub-header transition-element"
          id="subHeader"
          style={{
            backgroundColor: colorTheme,
            color: textColor,
            height: headerStripHeight,
            top: `${primaryHeaderHeight}px`
          }}
        >
          <div
            className="sub-header-wrapper transition-element"
            style={{
              backgroundColor: colorTheme,
              height: headerStripHeight
            }}
          >
            {newDesignLuxe ? null : (
              <div className="sub-store-header" style={{ height: `${subHeaderLogoHeight}px` }}>
                <a href={subdomain ? `/` : '#'} style={{ height: `${subHeaderLogoHeight}px` }}>
                  <img
                    src={subBrandLogo}
                    className="sub-store-brand-icon transition-element"
                    alt={`${storeName} logo`}
                    style={{
                      height: `${subHeaderLogoHeight}px`,
                      minHeight: `${subHeaderLogoHeight}px`
                    }}
                  />
                </a>
              </div>
            )}
            <NavComp category={category} newDesignLuxe={newDesignLuxe} />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

const mapStateToProps = state => {
  const { metaData, flags, bannerInfo = {}, productsAdditionalInfo = {} } = state;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const { priceRevealMetaInfo = {} } = productsAdditionalInfo;
  const { isThemeEnableWeb } = getStreetFlags(state);

  return {
    newDesignLuxe,
    metaData,
    isStore: metaData.sis,
    runtimeBanners: getRuntimeBannersFlag(flags),
    runtimeBannersSis: getRuntimeBannersSisFlag(flags),
    earlyAccessFlag: getEarlyAccessFlag(flags),
    priceRevealMetaInfo,
    flags,
    isStreet: isThemeEnableWeb === 'ON' && storeName === STREET_STORE,
    storeName
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchData: dispatch(actions.getCartWishlistCount())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
